module.exports = __webpack_public_path__ + "assets/post-role.79c88b13.svg";